import React, { useState } from 'react';
import { useTranslation } from '../../i18n.ts';
import { useSessionStore } from '../../stores/useSessionStore.ts';
import { ApiService, getErrorMessage } from '../../services/ApiService.ts';
import { useToast } from './Toast.tsx';

/**
 * #1853 — besluit Twan 21 okt: na een mislukte betaling staat het account meteen op
 * Gratis. Deze balk staat dan op elke pagina en brengt de klant in één klik naar het
 * bijwerken van zijn betaalmethode. Niet wegklikbaar: hij verdwijnt zodra de betaling
 * gelukt is (Stripe zet de status dan terug op active).
 */
const BetalingMisluktBalk: React.FC = () => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const status = useSessionStore(
    (s) => (s.user as unknown as Record<string, unknown> | null)?.subscription_status
  );
  const [bezig, setBezig] = useState(false);

  if (status !== 'past_due') return null;

  const bijwerken = async () => {
    setBezig(true);
    try {
      const { url } = await ApiService.createPortalSession();
      window.location.href = url;
    } catch (e) {
      toast(getErrorMessage(e, t) || t('operationFailed'), 'error');
      setBezig(false);
    }
  };

  return (
    <div
      role="alert"
      data-testid="betaling-mislukt-balk"
      className="shrink-0 flex flex-wrap items-center justify-between gap-3 px-4 py-2 text-sm font-medium bg-amber-50 text-amber-900 border-b border-amber-200"
    >
      <span>{t('betalingMisluktBalk')}</span>
      <button
        type="button"
        onClick={bijwerken}
        disabled={bezig}
        className="px-3 py-1 rounded-md bg-pt-forest text-pt-gold text-xs font-bold hover:brightness-110 disabled:opacity-60"
      >
        {t('updatePaymentMethod')}
      </button>
    </div>
  );
};

export default BetalingMisluktBalk;
